import type IntlService from "ember-intl/services/intl";

/**
 * Returns the translation or the default option if no translation is found.
 */
export default function tWithDefault(
  intl: IntlService,
  key: string | undefined,
  defaultOption: string
): string {
  const translation = intl.getTranslation(key || "", "fr-fr");
  return translation ? (translation as string) : defaultOption;
}

/**
 * This is usefull if we want to merge several translation base key.
 * @example tWithBaseKeys(intl, ["consultation-history", "consultation-report-types"], "dentist" )
 */
export function tWithBaseKeys(
  intl: IntlService,
  baseKeys: string[],
  key: string
): string {
  for (let i = 0; i < baseKeys.length; i++) {
    const translation = intl.getTranslation(`${baseKeys[i]}.${key}`, "fr-fr");
    if (translation) {
      return translation;
    }
  }

  return `Missing translation "[${baseKeys.join(",")}].${key}"`;
}
